import { AccredibleMultiSearchFilterComponent } from '@accredible-frontend-v2/new-components/multi-search-filter';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'accredible-themeable-multiple-search-input',
  templateUrl: './multiple-search-input.component.html',
  styleUrls: [`./multiple-search-input.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleThemeableMultipleSearchInputComponent extends AccredibleMultiSearchFilterComponent {}
